<h1> REGISTRATION </h1>
<p style="color: var(--cifris_orange);">
	Registration permanently closed (registration deadline was September 16th).
</p>
<p>
	The fees of CIFRIS24 are the following. <br>
	Fees are lower for De Cifris members. Membership costs 20 EUR, reduced to 5 EUR for young members. It is
	restricted to EU citizens.

</p>
<h2>MAIN EVENT (Sept. 25th, 26th)</h2>
The fee covers
<ul>
	<li>Free entrance to the main conference room;</li>
	<li>Coffee breaks and lunches (September 25th and 26th).</li>
</ul>
and doesn't cover
<ul>
	<li>Workshops;</li>
	<li>Social dinner.</li>
</ul>
<table class="fee-table">
	<tbody>
		<tr>
			<td class="item"><b>regular fee</b></td>
			<td class="fee">260 EUR</td>
		</tr>
		<tr>
			<td class="item"><b>regular fee</b> <br> members of: Unione Matematica Italiana, IEEE Computer
				Society, IEEE Information
				Theory Society</td>
			<td class="fee">240 EUR</td>
		</tr>
		<tr>
			<td class="item"><b>regular fee </b> <br> young participants (under 30 as of Jan. 1st 2025)</td>
			<td class="fee">200 EUR</td>
		</tr>
		<tr>
			<td class="item"><b style="color: var(--cifris_orange);">members of De Cifris </b> <br> “ordinario”,
				”benemerito”, “fondatore”, "giovane"
			</td>
			<td class="fee" style="color: var(--cifris_orange);">130 EUR</td>
		</tr>
	</tbody>
</table>
<hr>
<!-------------------------------------------------------------------->
<h2>WORKSHOPS (Sept. 27th)</h2>
The fee covers
<ul>
	<li>Free entrance to the workshop rooms;</li>
	<li>Coffee breaks and lunches (September 27th).</li>
</ul>
and doesn't cover
<ul>
	<li>Main event;</li>
	<li>Social dinner.</li>
</ul>
<table class="fee-table">
	<tbody>
		<tr>
			<td class="item"><b>regular fee</b></td>
			<td class="fee">150 EUR</td>
		</tr>
		<tr>
			<td class="item"><b>regular fee</b> <br> members of: Unione Matematica Italiana, IEEE Computer
				Society, IEEE Information
				Theory Society</td>
			<td class="fee">120 EUR</td>
		</tr>
		<tr>
			<td class="item"><b>regular fee </b> <br> young participants (under 30 as of Jan. 1st 2025)</td>
			<td class="fee">110 EUR</td>
		</tr>
		<tr>
			<td class="item"><b style="color: var(--cifris_orange);">members of De Cifris </b> <br> “ordinario”,
				”benemerito”, “fondatore”, "giovane"
			</td>
			<td class="fee" style="color: var(--cifris_orange);">60 EUR</td>
		</tr>
	</tbody>
</table>
<!-------------------------------------------------------------------->
<hr>
<h2>MAIN CONFERENCE AND WORKSHOPS (Sept. 25th, 26th, 27th)</h2>
This fee (the <b>joint fee</b>) covers
<ul>
	<li>Free entrance to the main conference room;</li>
	<li>Free entrance to the workshop rooms;</li>
	<li>Coffee breaks and lunches (September 25th, 26th and 27th).</li>
</ul>
and doesn't cover
<ul>
	<li>Social dinner.</li>
</ul>
<table class="fee-table">
	<tbody>
		<tr>
			<td class="item"><b>regular fee</b></td>
			<td class="fee">350 EUR</td>
		</tr>
		<tr>
			<td class="item"><b>regular fee</b> <br> members of: Unione Matematica Italiana, IEEE Computer
				Society, IEEE Information
				Theory Society</td>
			<td class="fee">300 EUR</td>
		</tr>
		<tr>
			<td class="item"><b>regular fee </b> <br> young participants (under 30 as of Jan. 1st 2025)</td>
			<td class="fee">250 EUR</td>
		</tr>
		<tr>
			<td class="item"><b style="color: var(--cifris_orange);">members of De Cifris </b> <br> “ordinario”,
				”benemerito”, “fondatore”, "giovane"
			</td>
			<td class="fee" style="color: var(--cifris_orange);">160 EUR</td>
		</tr>
	</tbody>
</table>
<hr id="social-dinner">
<!-------------------------------------------------------------------->
<h2> SOCIAL DINNER (Sept. 25th)</h2>
<p>
	The additional fee for the social dinner is 50 EUR, and covers the dinner taking place in the evening of September
	25th.
	<br>
	If you already registered and wish to add the social dinner to your existing registration, contact us at <a
		href="mailto:cifris24@decifris.it">cifris24&#64;decifris.it</a>.
	<br> <br>
	It is possible to join the social dinner with a Companion (Companion fee: 50 EUR), subject to the availability of
	seats at the venue. Please select the <b>Companion fee</b> option below to pay for a companion, then send an
	email to
	<a href="mailto:cifris24@decifris.it">cifris24&#64;decifris.it</a>.
</p>
<!-------------------------------------------------------------------->


<hr id="payment"><!------------------------------------------------------------------------>

<h2> PAYMENT </h2>
<p>
	Before paying, please send an email to <a href="mailto:cifris24@decifris.it">cifris24&#64;decifris.it</a> to
	register.
	<br>
	Accepted payment methods are wire transfer or credit card (NEXI, via the form below).
	<br>
	<br>
	In the email, please specify whether you pay yourself or your company/institution pays for you (in that
	case,
	please also attach its fiscal data). <br>
</p>
<p style="color: red;">
	Registration permanently closed (registration deadline was September 16th).
</p>
<form id="payForm" class="form" method="POST" (ngSubmit)="checkAndPay($event)">
	<p>
		<b style="color:var(--cifris_blue)">CIFRIS24 payment via NEXI</b>
	</p>
	<label> Attendance type </label>
	<div>
		<input type="radio" id="all" name="participation" checked="checked" (click)=setFee()>
		<label for="all"> Main event <b>and</b> workshops (Sep. 25th, 26th, 27th) </label><br>

		<input type="radio" id="main_event" name="participation" (click)=setFee()>
		<label for="main_event"> Main event (Sep. 25th, 26th) </label><br>

		<input type="radio" id="workshops" name="participation" (click)=setFee()>
		<label for="workshops"> Workshops (Sep. 27th) </label>
	</div>

	<label> Fee type </label>
	<div>
		<input type="radio" id="regular" name="fee" (click)=setFee()>
		<label for="regular"> Regular fee </label><br>

		<input type="radio" id="scientific_memebers" name="fee" (click)=setFee()>
		<label for="scientific_memebers">
			Regular fee for members of Unione Matematica Italiana, IEEE Computer Society, IEEE Information Theory
			Society
		</label><br>

		<input type="radio" id="young" name="fee" (click)=setFee()>
		<label for="young"> Regular fee for young participants </label><br>

		<input type="radio" id="member" name="fee" checked="checked" (click)=setFee()>
		<label for="member">
			Fee for De Cifris members (“ordinario”, ”benemerito”, “fondatore”, "giovane")
		</label> <br>

		<input type="radio" id="companion" name="fee" (click)=setFee()>
		<label for="companion">
			Companion fee (social dinner only)
		</label>
	</div>

	<label> Others </label>
	<div>
		<input type="checkbox" id="dinner" name="dinner" (click)=checkDinner($event)>
		<label for="dinner">
			Dinner
		</label>
	</div>

	<!-- Hidden input -->
	<input type="hidden" id="alias" name="alias" value={{ALIAS}}>
	<input type="hidden" id="importo" name="importo">
	<input type="hidden" id="divisa" name="divisa" value={{DIVISA}}>
	<input type="hidden" id="codTrans" name="codTrans">
	<input type="hidden" id="url" name="url">
	<input type="hidden" id="url_back" name="url_back">
	<input type="hidden" id="mac" name="mac">
	<input type="hidden" id="mail" name="mail">
	<input type="hidden" id="languageId" name="languageId" value="ENG">
	<input type="hidden" id="descrizione" name="descrizione">
	<input type="hidden" id="Note1" name="Note1" value="Enrollment for CIFRIS24.">
	<input type="hidden" id="nome" name="nome">
	<input type="hidden" id="cognome" name="cognome">

	<hr><!------------------------------------------------------------------------>

	<p style="font-weight: bold;">
		Total: € {{fee/100}}.00
	</p>

	<!-- Submit input -->
	<!--
	<input type="submit" value="Pay Now" disabled/>
	-->
	<mat-card style="
	background-color: var(--cifris_azure);
	color: var(--cifris_scarlet);
	text-align: center;
	">
		Pay now <br>
		<i style="font-size: small;">- 
			registration permanently closed (registration deadline was September 16th) -</i>
	</mat-card>

	<p class="footnote">
		De Componendis Cifris kindly requests your consent for the processing of your personal data provided in the
		payment form. Your data will be sent by Nexi to us after your payment. The Association declares that this
		information is essential for event planning, communication purposes, and addressing any special requests.
		Your personal data will be securely deleted upon the conclusion of the event, unless you have a longer
		collaboration with De Componendis Cifris, such as being one of our members.
	</p>
</form>